import GridRow from "./grid-row";
import dateWrapper from "core/lib/date-wrapper";
import { DimensionBlock } from "core/providers/grid.store";
import { observer } from "mobx-react-lite";
import { GridRowItemProps } from "./types";

const renderMargin = 8;

//Need to be observer?
const GridRowItem = observer((props: GridRowItemProps) => {
    const {
        dateItem,
        channelNumber,
        channelIndex,
        gridContext,
        store,
        rowHeight,
        adjustedCurrentTime,
        timeWindow,
        gridCheck,
        midnight
    } = props;

    const verticalScrollIndexes = gridContext.verticalScrollIndexes;
    const isShow = channelIndex > (verticalScrollIndexes[0] - renderMargin)
        && channelIndex < (verticalScrollIndexes[1] + renderMargin);

    //Only so many channels are displayed at one time so only render what is needed.
    //E.g. there might be 100 channels but only 8 are shown
    if (!isShow) {
        return null;
    }

    const channel = store.schedule[channelNumber];

    if (!channel) {
        return null;
    }

    const ymd = dateWrapper(dateItem).yearMonthDay();

    const programmes = channel.programmes[ymd];

    const usePixelMinuteMultiplier = programmes && programmes.length > 0;

    const dimensionBlock = gridContext.dimensionBlock as DimensionBlock;

    const ppm = usePixelMinuteMultiplier
        ? dimensionBlock.pixelMinuteMultiplier
        : null;

    return <GridRow
        rowTop={rowHeight * channelIndex}
        channelNumber={channelNumber}
        channelName={channel.name}
        programmeArr={programmes}
        adjustedCurrentTime={adjustedCurrentTime}
        timeChunkWidth={dimensionBlock.timeChunk.width}
        PMM={ppm}
        gridCheck={gridCheck}
        timeWindow={timeWindow}
        midnight={midnight}
        dateItem={dateItem} />
});

export default GridRowItem;
